import { constructQuery } from '@repo/shared/helpers';
import { guardedClient as clientRequest } from '@repo/shared/helpers';
import { documentListSchema, DocumentsApiResponse } from '@repo/shared/domain';
import { Document } from '@repo/shared/domain';

export const getUserTaskDocuments = async (userId: string, documentIds: string[]): Promise<Document[]> => {
	try {
		const { body } = await clientRequest.get(`/api/users/${userId}/files?noPagination=true`, {
			schema: documentListSchema,
		});
		// Filter documents to only those that belong to the task
		return body.data.filter((doc: Document) => documentIds.includes(doc._id));
	} catch (error) {
		console.error('Failed to get task documents:', error);
		return [];
	}
};

export const getGroupDocument = async (groupId: string, documentId: string): Promise<Document | null> => {
	try {
		const query = constructQuery({
			all: 'yes',
			includeLogs: 'true',
			fileIds: documentId,
		});
		const { body } = await clientRequest.get<undefined, Document[]>(`/api/groups/${groupId}/files?${query}`, {
			schema: documentListSchema,
		});
		return body?.data?.[0] ?? null;
	} catch (error) {
		console.error('Failed to get group document:', error);
		return null;
	}
};

export const getGroupDocuments = async (
	groupId: string,
	params?: { filter?: string; page?: number },
): Promise<DocumentsApiResponse> => {
	const query = constructQuery({
		page: params?.page,
		all: params?.filter === 'all' ? 'yes' : '',
	});
	const { body } = await clientRequest.get<undefined, Document[]>(`/api/groups/${groupId}/files?${query}`, {
		schema: documentListSchema,
	});
	return body;
};

export const getUserDocument = async (userId: string, documentId: string): Promise<Document | null> => {
	try {
		const query = constructQuery({
			all: 'yes',
			includeLogs: 'true',
			fileIds: documentId,
			noPagination: 'true',
		});
		console.log(`/api/users/${userId}/files?${query}`);
		const { body } = await clientRequest.get(`/api/users/${userId}/files?${query}`, {
			schema: documentListSchema,
		});
		return body?.data?.[0] ?? null;
	} catch (error) {
		console.error('Failed to get user document:', error);
		return null;
	}
};

export const getUserDocuments = async (
	userId: string,
	query?: Record<string, string | undefined>,
): Promise<DocumentsApiResponse> => {
	const additionalQuery: Record<string, string | undefined> = {};
	if (query?.filter === 'all') {
		additionalQuery.all = 'yes';
	}
	if (query?.page !== undefined) {
		additionalQuery.page = query.page;
	} else {
		additionalQuery.noPagination = 'true';
	}
	const queryParams = constructQuery(additionalQuery);
	const { body } = await clientRequest.get(`/api/users/${userId}/files?${queryParams}`, {
		schema: documentListSchema,
	});
	return body;
};
